import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/mobile-menu.svg'
import _imports_1 from '../../assets/images/panda-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d2122062"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "menu"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Panda logo"
  })
], -1))
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "logout-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", {
      'application-successful':
        _ctx.$route.name === _ctx.routesPath.applicationSuccessful,
      'open-enrollment': _ctx.getEnrollment?.serviceType === 1,
    }])
  }, [
    _createElementVNode("div", {
      class: "mobile-menu",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", {
      class: _normalizeClass(["menu-list", { show: _ctx.showMobileMenu, paymentMethodCard: _ctx.isPaymentCard }])
    }, [
      (
          ((_ctx.getEnrollment?.serviceType === 0 &&
            _ctx.$route.name != _ctx.routesPath.applicationSuccessful) ||
            _ctx.getEnrollment?.serviceType === 1) &&
          _ctx.$route.name != _ctx.routesPath.enrollments
        )
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.menuItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'menu-' + item.icon,
              class: _normalizeClass(["menu-item", { [item.link]: true }])
            }, [
              _createVNode(_component_router_link, {
                class: _normalizeClass(["menu-icon", { active: _ctx.getActiveClass(item.priority) }]),
                to: { name: _ctx.getActiveClass(item.priority) ? item.link : '' }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    alt: item.title,
                    src: 
              require('@/assets/icons/' +
                item.icon +
                (_ctx.showMobileMenu && _ctx.getActiveClass(item.priority)
                  ? '-active'
                  : '') +
                '.svg')
            
                  }, null, 8, _hoisted_4)
                ]),
                _: 2
              }, 1032, ["class", "to"]),
              _createVNode(_component_router_link, {
                class: _normalizeClass(["menu-title", { active: _ctx.getActiveClass(item.priority) }]),
                to: { name: _ctx.getActiveClass(item.priority) ? item.link : '' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["class", "to"])
            ], 2))
          }), 128))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-primary logout-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
      }, " Log out ")
    ])
  ], 2))
}